"use strict";
exports.__esModule = true;
function parseQueryParams(queryString) {
    // get query string from url (optional) or window
    // we'll store the parameters here
    var queryParams = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        var arr = queryString.split('&');
        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {
                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!queryParams[key])
                    queryParams[key] = [];
                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    // @ts-ignore
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    queryParams[key][index] = paramValue;
                }
                else {
                    // otherwise add the value to the end of the array
                    queryParams[key].push(paramValue);
                }
            }
            else {
                // we're dealing with a string
                if (!queryParams[paramName]) {
                    // if it doesn't exist, create property
                    queryParams[paramName] = paramValue;
                }
                else if (queryParams[paramName] && typeof queryParams[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    queryParams[paramName] = [queryParams[paramName]];
                    queryParams[paramName].push(paramValue);
                }
                else {
                    // otherwise add the property
                    queryParams[paramName].push(paramValue);
                }
            }
        }
    }
    return queryParams;
}
exports.parseQueryParams = parseQueryParams;
function parseParts(partsString) {
    return partsString.split(/\/+/g).filter(function (part) {
        return part.length > 0;
    });
}
exports.parseParts = parseParts;
function parseUrl(url) {
    var routeParts = {
        parts: [],
        queryParams: {}
    };
    var splitUrl = url.split('?');
    if (splitUrl.length > 1) {
        routeParts.queryParams = parseQueryParams(splitUrl[1]);
        routeParts.parts = parseParts(splitUrl[0]);
    }
    else {
        routeParts.parts = parseParts(url);
    }
    return routeParts;
}
exports.parseUrl = parseUrl;
//# sourceMappingURL=parser.js.map